import React, { useEffect, useState } from 'react';
import { useTheme } from '@emotion/react';
import { useNavigate, useParams } from 'react-router-dom';
import MainCard from './cards/MainCard';
import {
  Autocomplete,
  Button,
  Grid,
  Popper,
  TextField,
  FormControlLabel,
  FormControl,
  FormLabel,
  RadioGroup,
  Radio
} from '@mui/material';
import toast from 'react-hot-toast';
import { isEmpty, isValidPhoneNumber, validateEmail } from 'utils/validator';
import { get, post, put } from './../axios/apiService';
import LoadingBackdrop from './full-screen-loadder/LoadingBackdrop';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import styled from '@emotion/styled';
import countries from '../utils/countries_states.json';
import dayjs from 'dayjs';
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import parsePhoneNumberFromString from 'libphonenumber-js';

const CustomPopper = styled(Popper)({
  '& .MuiAutocomplete-paper': {
    backgroundColor: '#f5f5f5',
    color: '#000'
  }
});

function AddEditCustomerForm({ title = '' }) {
  const theme = useTheme();
  const id = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [customer, setCustomer] = useState({
    givenName: '',
    displayName: '',
    emailId: '',
    mobileNumber: '',
    city: '',
    country: null,
    state: null,
    postalCode: '',
    dateOfBirth: null,
    gender: '',
    address: "",
    changePasswordOnNextSignIn: false
  });

  const [formErrors, setFormErrors] = useState({});
  const [isValidation, setIsValidation] = useState(false);

  const [selectedCountry, setSelectedCountry] = useState(null);
  const [allState, setAllState] = useState([]);
  const [selectedState, setSelectedState] = useState(null);

  useEffect(() => {
    if (isValidation) {
      validator();
    }
  }, [customer.displayName, customer.emailId, customer.givenName, customer.mobileNumber, customer.city, isValidation,
  customer.address]);

  useEffect(() => {
    if (id.id != undefined && id.id != null) {
      const getByIdCustomer = async () => {
        setIsLoading(true);
        try {
          let response = await get(`Customer/${id.id}`, null);
          if (response != null) {
            let country = countryByName(response?.country);
            let state = stateByName(country, response?.state);
            setCustomer({
              givenName: response.givenName || '',
              displayName: response.displayName || '',
              emailId: response.emailId || '',
              mobileNumber: response.mobileNumber || '',
              changePasswordOnNextSignIn: response.changePasswordOnNextSignIn !== undefined ? response.changePasswordOnNextSignIn : true,
              city: response.city,
              postalCode: response?.postalCode,
              dateOfBirth: response?.brthOfDate,
              gender: response?.gender,
              address: response?.address
            });
            setSelectedCountry(country);
            setAllState(country?.states);
            setSelectedState(state);
            setSelectedDate(dayjs(response?.dateOfBirth));
          }
        } catch (err) {
          console.error(err.message);
          toast.error(err.response.data);
        } finally {
          setIsLoading(false);
        }
      };
      getByIdCustomer();
    }
  }, [id]);
  console.log(selectedDate, "selecteddate")
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    // const validatedValue = name === 'postalCode' ? value.replace(/[^0-9]/g, '') : value;
    setCustomer((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleSubmit = async () => {
    if (!validator()) return;
    setIsValidation(true);
    const apiUrl = id.id != undefined && id.id != null ? `Customer/${id.id}` : 'Customer';

    let param = {
      country: selectedCountry?.name,
      state: selectedState?.name,
      city: customer.city,
      changePasswordOnNextSignIn: customer.changePasswordOnNextSignIn,
      dateOfBirth: selectedDate,
      displayName: customer.displayName,
      givenName: customer.givenName,
      emailId: customer.emailId,
      mobileNumber: customer.mobileNumber,
      postalCode: customer.postalCode,
      gender: customer.gender,
      address: customer.address
    };
    try {
      setIsLoading(true);
      let response = id.id ? await put(apiUrl, param) : await post(apiUrl, param);
      if (response) {
        if (id.id) {
          toast.success(id.id ? 'Customer updated successfully' : 'Customer added successfully');
        } else {
          toast.success(
            `Customer added successfully, GivenName : ${response?.givenName} , Email : ${response?.emailId} , Password:${response?.password}`
          );
        }
        navigate('/customer-management');
      }
    } catch (error) {
      toast.error("Customer with same data already exists.");
    } finally {
      setIsLoading(false);
    }
  };

  const validator = () => {
    const errors = {};
    if (isEmpty(customer?.givenName)) {
      errors.givenName = "Please enter First name";
    }

    if (isEmpty(customer?.emailId)) {
      errors.emailId = "Please enter email-id";
    }
    else if (!isEmpty(customer?.emailId) && !validateEmail(customer.emailId)) {
      errors.emailId = "Please enter a valid email";
    }
    else {
      delete errors.emailId;
    }

    if (isEmpty(customer.displayName)) {
      errors.displayName = "Please enter Last name";
    }
    let mobileNumber = customer.mobileNumber.startsWith('+') ? customer.mobileNumber : `+${customer.mobileNumber}`;
    let phoneNumber = parsePhoneNumberFromString(mobileNumber);
    if (!phoneNumber || !phoneNumber.isValid()) {
      errors.mobileNumber = "Invalid Mobile Number";
    }
    // if (isEmpty(customer.mobileNumber ?? "")) {
    //   errors.mobileNumber = "Please Enter Mobile Number ";
    // } else if (!isValidPhoneNumber(customer.mobileNumber?.toString())) {
    //   errors.mobileNumber = "Invalid Phone Number";
    // } else {
    //   delete errors.mobileNumber;
    // }
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleCountryChange = (event, newValue) => {
    setSelectedCountry(newValue);
    setAllState(newValue?.states);
    setSelectedState(null);
  };
  const handleStateChange = (event, newValue) => {
    setSelectedState(newValue);
  };

  const countryByName = (name) => {
    var country = countries?.find((x) => x.name == name);
    if (country != null) {
      return country;
    } else {
      return null;
    }
  };

  const stateByName = (country, name) => {
    var state = country?.states?.find(x => x.name == name);
    if (state != null) {
      return state;
    } else {
      return null;
    }
  }

  const handlePhoneChange = (value) => {
    console.log(value); // Log the new phone number
    setCustomer((prevCustomer) => ({
      ...prevCustomer,
      mobileNumber: value, // Update the mobileNumber
    }));
  };
  return (
    <div>
      <MainCard title={title} backButton={{ onClick: () => navigate('/customer-management') }}>
        <Grid container spacing={2}>

          {/* Personal Information Section */}
          <Grid item xs={12}>
            <fieldset style={{
              border: '2px solid #364152',
              borderRadius: '8px',
              padding: '20px',
              marginBottom: '20px',
            }}>
              <legend style={{
                color: '#364152',
                fontSize: '1.2em',
                padding: '0 10px',
                fontWeight: 'bold',
                backgroundColor: '#f0f0f0',
                borderRadius: '5px',
              }}>
                Personal Information
              </legend>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6} lg={4}>
                  <TextField fullWidth label="First Name *" name="givenName" type="text" value={customer.givenName}
                    onChange={handleInputChange} />
                  <div style={{ color: 'red' }}>{formErrors.givenName}</div>
                </Grid>
                <Grid item xs={12} md={6} lg={4}>
                  <TextField fullWidth label="Last Name *" name="displayName" type="text" value={customer.displayName}
                    onChange={handleInputChange} />
                  <div style={{ color: 'red' }}>{formErrors.displayName}</div>
                </Grid>
                <Grid item xs={12} md={6} lg={4}>
                  <TextField fullWidth label="Email Id *" name="emailId" type="text" value={customer.emailId}
                    onChange={handleInputChange} />
                  <div style={{ color: 'red' }}>{formErrors.emailId}</div>
                </Grid>
                <Grid item xs={12} md={6} lg={4}>
                  {/* <TextField fullWidth label="Mobile Number *" name="mobileNumber" type="text" value={customer.mobileNumber}
                    onChange={handleInputChange} /> */}
                  <PhoneInput
                    country={'in'}
                    onChange={handlePhoneChange}
                    inputStyle={{
                      width: '100%',
                      height:'49px',
                      borderRadius: '12px',
                    }}
                  />
                  <div style={{ color: 'red' }}>{formErrors.mobileNumber}</div>
                </Grid>
                <Grid item xs={12} md={6} lg={4}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      label="Date Of Birth"
                      value={selectedDate}
                      slotProps={{ textField: { fullWidth: true } }}
                      onChange={(newValue) => setSelectedDate(newValue)}
                      disableFuture
                      renderInput={(params) => <TextField {...params} sx={{ backgroundColor: "pink" }} />}
                    />
                  </LocalizationProvider>
                </Grid>
              </Grid>
            </fieldset>
          </Grid>

          {/* Address Section */}
          <Grid item xs={12}>
            <fieldset style={{
              border: '2px solid #364152',
              borderRadius: '8px',
              padding: '20px',
              marginBottom: '20px',
            }}>
              <legend style={{
                color: '#364152',
                fontSize: '1.2em',
                padding: '0 10px',
                fontWeight: 'bold',
                backgroundColor: '#f0f0f0',
                borderRadius: '5px',
              }}>
                Address
              </legend>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6} lg={4}>
                  <Autocomplete
                    disablePortal
                    options={countries}
                    getOptionLabel={(option) => option.name}
                    onChange={handleCountryChange}
                    PopperComponent={CustomPopper}
                    value={selectedCountry}
                    renderInput={(params) => <TextField {...params} label="Country" />}
                  />
                </Grid>
                <Grid item xs={12} md={6} lg={4}>
                  <Autocomplete
                    disablePortal
                    disabled={!selectedCountry}
                    options={allState}
                    getOptionLabel={(option) => option.name}
                    onChange={handleStateChange}
                    PopperComponent={CustomPopper}
                    value={selectedState}
                    renderInput={(params) => <TextField {...params} label="State" />}
                  />
                </Grid>
                <Grid item xs={12} md={6} lg={4}>
                  <TextField fullWidth label="Adress" name="address" type="text" value={customer.address}
                    onChange={handleInputChange} />
                </Grid>
                <Grid item xs={12} md={6} lg={4}>
                  <TextField fullWidth label="City" name="city" type="text" value={customer.city}
                    onChange={handleInputChange} />
                </Grid>
                <Grid item xs={12} md={6} lg={4}>
                  <TextField fullWidth label="Postal Code" name="postalCode" type="text" value={customer.postalCode}
                    onChange={handleInputChange} />
                </Grid>
              </Grid>
            </fieldset>
          </Grid>

          {/* Gender Section */}
          <Grid item xs={12}>
            <fieldset style={{
              border: '2px solid #364152',
              borderRadius: '8px',
              padding: '20px',
              marginBottom: '20px',
            }}>
              <legend style={{
                color: '#364152',
                fontSize: '1.2em',
                padding: '0 10px',
                fontWeight: 'bold',
                backgroundColor: '#f0f0f0',
                borderRadius: '5px',
              }}>
                Gender
              </legend>
              <FormControl>
                <FormLabel id="demo-radio-buttons-group-label">Gender</FormLabel>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  defaultValue="female"
                  name="gender"
                  value={customer?.gender}
                  onChange={handleInputChange}
                  style={{ display: 'flex', flexDirection: 'row' }}
                >
                  <FormControlLabel value="male" control={<Radio />} label="Male" />
                  <FormControlLabel value="female" control={<Radio />} label="Female" />
                  <FormControlLabel value="other" control={<Radio />} label="Other" />
                </RadioGroup>
              </FormControl>
            </fieldset>
          </Grid>
        </Grid>

        <Button variant="contained" sx={{ marginTop: '20px', padding: '5px 30px' }} onClick={handleSubmit}>
          Save
        </Button>
      </MainCard>


      <LoadingBackdrop open={isLoading} />
    </div>
  );
}
export default AddEditCustomerForm;
